module.exports = __webpack_public_path__ + "static/media/cover-0.42308d63.png";